import React from "react";
import {Form} from "../../XLibItems";
import {XFormFooter} from "@michalrakus/x-react-web-lib/XFormFooter";
import {XFormBaseModif} from "@michalrakus/x-react-web-lib/XFormBaseModif";
import {XCheckbox} from "@michalrakus/x-react-web-lib/XCheckbox";
import {XObject} from "@michalrakus/x-react-web-lib/XObject";
import {XFormHeader} from "@michalrakus/x-react-web-lib/XFormHeader";
import {XInputDate} from "@michalrakus/x-react-web-lib/XInputDate";
import {XInputDecimal} from "@michalrakus/x-react-web-lib/XInputDecimal";
import {XInputText} from "@michalrakus/x-react-web-lib/XInputText";
import {XUtils} from "@michalrakus/x-react-web-lib/XUtils";

@Form("UpozorneniePreObdobie")
export class UpozorneniePreObdobieForm extends XFormBaseModif {

    createNewObject(): XObject {
        return {zapnute: false, version: 0};
    }

    render() {
        return (
            <div>
                <XFormHeader form={this} label="Upozornenie"/>
                <div className="x-form-row">
                    <div className="x-form-col">
                        <XInputDecimal form={this} field="id" label="ID" readOnly={true}/>
                        <XInputDate form={this} field="modifDate" label="Dátum modif." readOnly={true}/>
                        <XInputText form={this} field="modifXUser.name" label="Modifikoval" size={20}/>
                        <XCheckbox form={this} field="zapnute" label="Zapnuté"/>
                        <XInputDate form={this} field="datumOd" label="Dátum od"/>
                        <XInputDate form={this} field="datumDo" label="Dátum do"/>
                        <XInputText form={this} field="upozornenie" label="Upozornenie" inputStyle={{width: `50rem`}}/>
                    </div>
                </div>
                <XFormFooter form={this}/>
            </div>
        );
    }
}
